module.exports = __webpack_public_path__ + "static/media/workl-logo.03ed1bcd.png";